import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _LightTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { LightTheme5_0 } from "../LightTheme5_0";
export var LightTheme5_1 = createTheme({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function LightTheme5_1() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(LightTheme5_1, _BasicThemeClassForEx);
    return _createClass(LightTheme5_1, null, [{
      key: "mobileModalCloseButtonRightPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }, {
      key: "mobileModalCloseButtonTopPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }, {
      key: "mobileSidePageCloseButtonPadding",
      get: function get() {
        return this.mobileSidePageCloseButtonClickArea;
      }
    }, {
      key: "sidePageCloseButtonClickAreaTop",
      get: function get() {
        return this.modalCloseButtonClickAreaTop;
      }
    }, {
      key: "sidePageCloseButtonClickAreaBottom",
      get: function get() {
        return this.modalCloseButtonClickAreaBottom;
      }
    }, {
      key: "sidePageCloseButtonClickAreaLeft",
      get: function get() {
        return this.modalCloseButtonClickAreaLeft;
      }
    }, {
      key: "sidePageCloseButtonClickAreaRight",
      get: function get() {
        return this.modalCloseButtonClickAreaRight;
      }
    }]);
  }(BasicThemeClassForExtension), _LightTheme5_.modalCloseButtonClickAreaTop = '30px', _LightTheme5_.modalCloseButtonClickAreaBottom = '22px', _LightTheme5_.modalCloseButtonClickAreaLeft = '24px', _LightTheme5_.modalCloseButtonClickAreaRight = '28px', _LightTheme5_.mobileModalCloseButtonClickArea = '22px', _LightTheme5_.sidePageHeaderStickyOffset = '10px', _LightTheme5_.mobileSidePageCloseButtonClickArea = '22px', _LightTheme5_.sidePageCloseButtonWrapperFixedOffsetTop = '4px', _LightTheme5_.sidePageCloseButtonWrapperOffsetTop = '2px', _LightTheme5_),
  prototypeTheme: LightTheme5_0,
  themeMarkers: [markThemeVersion('5.1')]
});